import React from 'react';
import { View, StyleSheet, ScrollView, TouchableOpacity, Text } from 'react-native';
import { Card, Title } from 'react-native-paper';
import { colors, spacing, typography } from '../../constants/theme';

interface AdminMenuScreenProps {
  onNavigateToUserManagement: () => void;
  onNavigateToReviewTemplates: () => void;
  onNavigateToVendors: () => void;
  onNavigateToVendorTypes: () => void;
}

export const AdminMenuScreen: React.FC<AdminMenuScreenProps> = ({
  onNavigateToUserManagement,
  onNavigateToReviewTemplates,
  onNavigateToVendors,
  onNavigateToVendorTypes,
}) => {
  return (
    <View testID="admin-menu-screen" style={styles.container}>
      <ScrollView
        testID="admin-menu-scroll"
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}
      >
        <Title style={styles.pageTitle}>Administration</Title>
        
        <View style={styles.menuContainer}>
          <TouchableOpacity testID="admin-nav-users" onPress={onNavigateToUserManagement} style={styles.menuItemContainer}>
            <Card style={styles.menuCard}>
              <Card.Content style={styles.cardContent}>
                <View style={styles.iconContainer}>
                  <Text style={styles.icon}>👥</Text>
                </View>
                <View style={styles.textContainer}>
                  <Text style={styles.menuTitle}>User Management</Text>
                  <Text style={styles.menuDescription}>
                    Manage users, roles, and invitations. Create new user accounts and update permissions.
                  </Text>
                </View>
                <View style={styles.chevronContainer}>
                  <Text style={styles.chevron}>›</Text>
                </View>
              </Card.Content>
            </Card>
          </TouchableOpacity>

          <TouchableOpacity testID="admin-nav-review-templates" onPress={onNavigateToReviewTemplates} style={styles.menuItemContainer}>
            <Card style={styles.menuCard}>
              <Card.Content style={styles.cardContent}>
                <View style={styles.iconContainer}>
                  <Text style={styles.icon}>📋</Text>
                </View>
                <View style={styles.textContainer}>
                  <Text style={styles.menuTitle}>Review Templates</Text>
                  <Text style={styles.menuDescription}>
                    Manage review templates, categories, and questions. Configure the review system structure.
                  </Text>
                </View>
                <View style={styles.chevronContainer}>
                  <Text style={styles.chevron}>›</Text>
                </View>
              </Card.Content>
            </Card>
          </TouchableOpacity>

          <TouchableOpacity testID="admin-nav-vendors" onPress={onNavigateToVendors} style={styles.menuItemContainer}>
            <Card style={styles.menuCard}>
              <Card.Content style={styles.cardContent}>
                <View style={styles.iconContainer}>
                  <Text style={styles.icon}>🏢</Text>
                </View>
                <View style={styles.textContainer}>
                  <Text style={styles.menuTitle}>Vendors</Text>
                  <Text style={styles.menuDescription}>
                    Manage vendor information and relationships. Add, edit, and organize service providers.
                  </Text>
                </View>
                <View style={styles.chevronContainer}>
                  <Text style={styles.chevron}>›</Text>
                </View>
              </Card.Content>
            </Card>
          </TouchableOpacity>

          <TouchableOpacity testID="admin-nav-vendor-types" onPress={onNavigateToVendorTypes} style={styles.menuItemContainer}>
            <Card style={styles.menuCard}>
              <Card.Content style={styles.cardContent}>
                <View style={styles.iconContainer}>
                  <Text style={styles.icon}>🏷️</Text>
                </View>
                <View style={styles.textContainer}>
                  <Text style={styles.menuTitle}>Vendor Types</Text>
                  <Text style={styles.menuDescription}>
                    Manage vendor categories and types. Configure service provider classifications.
                  </Text>
                </View>
                <View style={styles.chevronContainer}>
                  <Text style={styles.chevron}>›</Text>
                </View>
              </Card.Content>
            </Card>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    padding: spacing.lg,
    paddingBottom: spacing.xxl,
  },
  pageTitle: {
    ...typography.h1,
    textAlign: 'center',
    marginBottom: spacing.xl,
    color: colors.text,
  },
  menuContainer: {
    gap: spacing.lg,
  },
  menuItemContainer: {
    // TouchableOpacity wrapper
  },
  menuCard: {
    backgroundColor: colors.surface,
    elevation: 2,
    shadowColor: colors.text,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  cardContent: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: spacing.lg,
  },
  iconContainer: {
    marginRight: spacing.md,
  },
  icon: {
    fontSize: 32,
  },
  textContainer: {
    flex: 1,
    marginRight: spacing.md,
  },
  menuTitle: {
    ...typography.h3,
    marginBottom: spacing.xs,
    color: colors.text,
  },
  menuDescription: {
    ...typography.body,
    color: colors.textSecondary,
    lineHeight: 20,
  },
  chevronContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  chevron: {
    fontSize: 24,
    color: colors.textSecondary,
    fontWeight: 'bold',
  },
});

export default AdminMenuScreen;
